import { Box, Typography } from '@mui/material';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import ApartmentIcon from '@mui/icons-material/Apartment';
import { styles } from './styles';



const TripPeriodRow = ({ period, vehicles, trips, color, isLast, onTripClick, onVehicleClick }) => (
    <Box
        sx={{
            background: '#fff',
            borderRadius: 2,
            border: '1px solid #e8edf2',
            p: 1.5,
            mb: isLast ? 0 : 1.5,
        }}
    >
        <Typography sx={styles.tripPeriodLabel}>{period.toUpperCase()}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'stretch', mt: 0.5 }}>
            {/* Vehicles column */}
            <Box sx={{ flex: 1 }}>
                <Typography sx={styles.tripColLabel}>Vehicles</Typography>
                <Typography sx={{ ...styles.tripVehicleNum("blue"), cursor: 'pointer' }}
                    onClick={onVehicleClick}
                >
                    {vehicles?.toLocaleString() ?? "-"}
                </Typography>
            </Box>

            {/* Vertical Divider */}
            <Box sx={{ width: '1px', background: '#e0e7ef', mx: 2, alignSelf: 'stretch' }} />

            {/* Trips column */}
            <Box sx={{ flex: 1 }}>
                <Typography sx={styles.tripColLabel} >Trips</Typography>

                <Typography
                    sx={{ ...styles.tripTripNum, cursor: 'pointer' }}
                    onClick={onTripClick}
                >
                    {trips?.toLocaleString() ?? "-"}
                </Typography>
            </Box>
        </Box>
    </Box>
);

const TripCard = ({ title, icon, color, rows, tankerType }) => (
    <Box sx={styles.tripSectionCard(color)} >
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Box sx={styles.tripIconBox(color)}>{icon}</Box>
            <Typography sx={{ fontWeight: 700, fontSize: 18, color: '#1a2d45' }}>{title}</Typography>
        </Box>
        {rows.map((row, i) => (
            <TripPeriodRow key={row.period} {...row} color={color} isLast={i === rows.length - 1}
                onTripClick={() => {
                    const fromDate = row.fromDate;
                    const toDate = row.toDate;
                    window.open(
                        `/tripslist?tankerType=${tankerType}&fromDate=${fromDate}&toDate=${toDate}&`,
                        '_blank'
                    );
                }}
                onVehicleClick={() => {
                    if (tankerType === "MS_HIRED") {
                        window.open(
                            `/vehiclelist?type=${tankerType}&filter=${row.period.toUpperCase()}&isWorkOrderVehicle=true`,
                            '_blank'
                        );
                    }
                    else {
                        window.open(
                            `/vehiclelist?type=${tankerType}&filter=${row.period.toUpperCase()}`,
                            '_blank'
                        );
                    }
                }}
            />
        ))}
    </Box>
);

const today = new Date();
const formatDate = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
};

const todayStr = formatDate(today);

const yesterday = new Date(today);
yesterday.setDate(today.getDate() - 1);
const yesterdayStr = formatDate(yesterday);

const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
const monthStartStr = formatDate(monthStart);

const TripDetailsPanel = ({ data }) => {
    const msHiredRows = [
        { period: 'Today', fromDate: todayStr, toDate: todayStr, vehicles: data?.msHiredVehiclesToday, trips: data?.msHiredTripsToday },
        { period: 'Yesterday', fromDate: yesterdayStr, toDate: yesterdayStr, vehicles: data?.msHiredVehiclesYesterday, trips: data?.msHiredTripsYesterday },
        { period: 'Monthly', fromDate: monthStartStr, toDate: todayStr, vehicles: data?.msHiredVehiclesMonthly, trips: data?.msHiredTripsMonthly },
    ];
    const departmentalRows = [
        { period: 'Today', fromDate: todayStr, toDate: todayStr, vehicles: data?.departmentalVehiclesToday, trips: data?.departmentalTripsToday },
        { period: 'Yesterday', fromDate: yesterdayStr, toDate: yesterdayStr, vehicles: data?.departmentalVehiclesYesterday, trips: data?.departmentalTripsYesterday },
        { period: 'Monthly', fromDate: monthStartStr, toDate: todayStr, vehicles: data?.departmentalVehiclesMonthly, trips: data?.departmentalTripsMonthly },
    ];
    return (
        <Box sx={styles.sectionCard}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <SwapHorizIcon sx={{ color: '#1a90ff', fontSize: 35 }} />
                <Box>
                    <Typography sx={styles.sectionTitle}>Trip Details</Typography>
                    <Typography sx={styles.sectionSubtitle}>Vehicle counts vs trips performed</Typography>
                </Box>
            </Box>

            <Box sx={{ display: 'flex', gap: 2 }}>
                <TripCard
                    title="MS-Hired"
                    color="blue"
                    icon={<DirectionsBusIcon sx={{ fontSize: 30, color: '#1a90ff' }} />}
                    rows={msHiredRows}
                    tankerType="MS_HIRED"
                />
                <TripCard
                    title="Departmental"
                    color="purple"
                    icon={<ApartmentIcon sx={{ fontSize: 30, color: '#7c3aed' }} />}
                    rows={departmentalRows}
                    tankerType="DEPARTMENTAL"
                />
            </Box>
        </Box>
    )
};
export default TripDetailsPanel